<template>
  <section class="section-2 grey wrapper">
    <div class="hd hd-flip">
      <h2 class="title">
        TTPS教练团
      </h2>
    </div>

    <div class="coach">
      <ul class="coach-list">
        <li
          v-for="(item, i) in coachList"
          :key="item.img"
          :class="returnCoachCls(i)"
        >
          <img :src="item.img">

          <div class="coach-title">
            <strong>{{ item.name }}</strong>
            <span>{{ item.title }}</span>
          </div>

          <div class="coach-intro">
            <span
              v-for="content in item.intro"
              :key="content"
            >
              {{ content }}
            </span>
          </div>
        </li>
      </ul>
    </div>

    <btn-contact name="C页-TTPS教练团-预约咨询" />
  </section>
</template>

<script>
import BtnContact from './BtnContact.vue';

export default {
  name: 'Section2',
  components: {
    BtnContact,
  },
  props: {
    coachList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      currentCoach: 1,
      currentStudent: 2,
    };
  },
  methods: {
    onCurrentChange(i) {
      this.currentCoach = i > this.coachList.length - 1 ? 0 : i < 0 ? this.coachList.length - 1 : i;
    },
    returnCoachCls(i) {
      return {
        prev: this.currentCoach === 0 ? i === this.coachList.length - 1 : this.currentCoach - 1 === i,
        current: this.currentCoach === i,
        next: this.currentCoach === this.coachList.length - 1 ? i === 0 : this.currentCoach + 1 === i,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.section-2 {
  padding-top: percentage(117px / $deviceWidth);
  padding-bottom: percentage(86px / $deviceWidth);

  &::after {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    margin-top: percentage((105px + 208px) / $deviceWidth);
    width: percentage(276px / $deviceWidth);
    padding-top: percentage(376px / $deviceWidth);
    background: url("~assets/C.png") center/contain no-repeat;

    @include hdpi() {
      background-image: url("~assets/C@2x.png");
    }
  }

  .mb {
    display: none;
  }

  &.active {
    .coach {
      &-list {
        li {
          animation: bounceIn .6s .8s both;

          &:nth-of-type(2) {
            animation-delay: .6s;
          }
          &:nth-of-type(3) {
            animation-delay: 1s;
          }
        }
      }
    }
  }

  .title {
    margin-right: percentage(214px / $deviceWidth);
    width: percentage(479px / $deviceWidth);
    padding-top: percentage(138px / $deviceWidth);
  }

  .coach {
    $contentWidth: 680px * 2 + 80px;
    position: relative;
    z-index: 2;
    margin: percentage(56px / $deviceWidth) auto percentage(82px / $deviceWidth);
    width: percentage($contentWidth / $deviceWidth);

    &-list {
      display: flex;
      justify-content: space-between;
      margin: 0;
      padding: 0;
      z-index: 2;
      white-space: nowrap;

      li {
        display: inline-block;
        padding: 0;
        width: percentage(680px / $contentWidth);
        text-align: center;
        transition: all .3s ease-in-out;
        opacity: 0;

        img {
          display: block;
          width: 100%;
        }

        strong {
          margin-top: percentage(20px / 340px);
          font-size: 24px;
          color: #3A4047;
        }
      }
    }

    &-title {
      z-index: 4;
      font-size: 20px;
      color: #3A4047;
      line-height: 42px;
      text-align: center;
      margin-top: percentage(36px / 680px);
      margin-bottom: percentage(64px / 680px);

      strong {
        font-size: 32px;
        line-height: 32px;
      }

      span {
        position: relative;
        display: block;
        opacity: .8;
        font-weight: 600;
        white-space: normal;

        &::after {
          content: "";
          position: absolute;
          bottom: -18px;
          left: 50%;
          width: 64px;
          height: 3px;
          margin-left: -32px;
          background: #4481DB;
          border-radius: 2px;
        }
      }
    }

    &-intro {
      font-size: 18px;
      color: #3A4047;
      line-height: 32px;
      opacity: .8;
      white-space: normal;
      text-align: center;

      span {
        display: block;
        hyphens: auto;
      }
    }
  }

  @include mediaWidth(1440px) {
    .coach {
      &-title {
        strong {
          font-size: 24px;
        }
      }
      &-list {
        li {
          strong {
            font-size: 22px;
          }
        }
      }
      &-title {
        strong {
          font-size: 24px;
        }
        span {
          font-size: 16px;
          line-height: 28px;
        }
      }
      &-intro {
        font-size: 16px;
        line-height: 28px;
      }
    }
  }

  @include mediaWidth(#{$mbWidth}) {
    $outerWidth: 406px;
    $innerWidth: 680px;

    padding-top: percentage(47px / $mbWidth);

    &::after {
      width: percentage(210px / $mbWidth);
      padding-top: percentage(234px / $mbWidth);
      margin-top: percentage(563px / $mbWidth);
    }

    .coach {
      width: percentage($innerWidth / $mbWidth);
      margin: percentage(74px / $mbWidth) auto percentage(64px / $mbWidth);

      &-list {
        flex-direction: column;
        li {
          width: 100%;
          margin-bottom: 32px;

          strong {
            font-size: 14px;
          }

          &:last-child {
            margin-bottom: 0;
          }
        }
      }

      &-title {
        font-size: 14px;
        line-height: 28px;

        strong {
          font-size: 20px;
        }
      }
    }
  }

  @include mediaWidth(528px) {
    .coach {
      margin: percentage(74px / $mbWidth) auto percentage(48px / $mbWidth);
      &-title, &-intro {
        span {
          font-size: 10px;
          line-height: 20px;
        }
        strong {
          font-size: 16px;
          line-height: 28px;
        }
      }
      &-intro {
        left: percentage(160px / 362px);
        line-height: 20px;
        span {
          font-size: 10px;
        }
      }
    }
  }
}
</style>
